import { configureStore } from '@reduxjs/toolkit'

import homepageReducer from './homepage.reducer'
import tooltipReducer from './tooltip.reducer'
import headerReducer from './header.reducer'
import favoritesReducer from './favorites.reducer'

// A factory rather than a module-level singleton: under SSR the module scope is
// shared by every request an isolate handles, so one store would let one
// visitor's transient UI state (open tooltip, header state) leak into another
// visitor's rendered HTML. The root route makes one store per render instead.
//
// favoritesStore raises the stakes of that: it holds account data, so a shared
// store would leak one user's saved words into another user's HTML rather than
// just a stray tooltip.
export const makeStore = () =>
   configureStore({
      reducer: {
         homepageStore: homepageReducer,
         tooltipStore: tooltipReducer,
         headerStore: headerReducer,
         favoritesStore: favoritesReducer,
      },
   })

export type AppStore = ReturnType<typeof makeStore>
export type RootState = ReturnType<AppStore['getState']>
